import { render, staticRenderFns } from "./UpdatesList.vue?vue&type=template&id=cd37b63a&scoped=true"
import script from "./UpdatesList.vue?vue&type=script&lang=js"
export * from "./UpdatesList.vue?vue&type=script&lang=js"
import style0 from "./UpdatesList.vue?vue&type=style&index=0&id=cd37b63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd37b63a",
  null
  
)

export default component.exports